import GtagService from 'modules/app/services/ga/GtagService';

class ContentEvents {
  sendClick = (options) => {
    GtagService.sendClick({
      subcategory: 'Content',
      ...options
    });
  };

  sendTabEvent = (isExtraTab) => {
    const event = isExtraTab
      ? { label: 'Extra', where: 'ExtraTab' }
      : { label: 'Main', where: 'MainTab' };

    this.sendClick(event);
  };

  sendModuleEvent = ({ label }) => {
    this.sendClick({
      where: 'ManageModule',
      label
    });
  };

  sendCreateEvent = ({ label }) => {
    this.sendClick({
      where: 'CreateContent',
      label
    });
  };

  sendPageEvent = ({ label }) => {
    this.sendClick({
      where: 'ManagePage',
      label
    });
  };
}

export default new ContentEvents();
